import { Icon } from "@blueprintjs/core";
import * as React from "react";

type OrderByIconName = "caret-down" | "caret-up" | "double-caret-vertical";

const OrderByIcon = ({ isAscending, isActive }: { isActive: boolean; isAscending: boolean }) => {
  let iconName: OrderByIconName = "caret-up";
  if (!isActive) {
    iconName = "double-caret-vertical";
  } else if (!isAscending) {
    iconName = "caret-down";
  }

  return <Icon icon={iconName} className={`header-icon is-active-${isActive}`} />;
};

export default OrderByIcon;
